import { memo, useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { isNil, noop, unionBy } from 'lodash';
// Import Hooks
import useToaster from 'hooks/UseToaster';
import useAutocompleteRequest from 'hooks/UseAutocompleteRequest';
// Import UI Components
import { Dropdown } from '@geneui/components';

const AutocompleteDropdown = ({ getRequest, getData, value, data, ...rest }) => {
    const [dropdownDataList, setDropdownDataList] = useState([]);
    const [dataList, setDataList] = useState(data ?? []);
    const { showToaster } = useToaster();
    const { getAutocompleteRequest, cancelRequest } = useAutocompleteRequest();

    const getDataList = (searchValue = '') => {
        const requestObj = getAutocompleteRequest(getRequest);

        getData(requestObj, searchValue, showToaster)
            .then((data) => {
                const tmpListData = !isNil(data) ? unionBy(data, dropdownDataList, 'value') : dropdownDataList;
                setDataList((prev) => unionBy(prev, tmpListData, 'value'));
            })
            .catch(({ AlertType, AlertMessage }) => {
                showToaster(AlertType, AlertMessage);
            });
    };

    const handleChange = (value) => {
        setDropdownDataList(value);
    };

    const onSearch = (value) => {
        getDataList(value);
    };

    const cleanUp = () => {
        return () => {
            cancelRequest('AutocompleteDropdown:request');
        };
    };

    // eslint-disable-next-line react-hooks/exhaustive-deps
    useEffect(cleanUp, []);

    useEffect(() => {
        getDataList();
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    return (
        <Dropdown
            data={dataList}
            onChange={handleChange}
            value={value}
            isMultiSelect={true}
            onSearch={onSearch}
            customSearch={false}
            hideSelectAll={true}
            {...rest}
        />
    );
};

AutocompleteDropdown.propTypes = {
    value: PropTypes.array,
    getRequest: PropTypes.func,
    getData: PropTypes.func,
};

AutocompleteDropdown.defaultProps = {
    value: [],
    getRequest: noop,
    getData: noop,
};

export default memo(AutocompleteDropdown);
